import LinkRootBlocks from '../../../components/blocks/LinkRootBlocks.jsx';
import ROUTES from '../../../routes/Routes.js';

export default function LinkrootPricing() {
    return (
        <LinkRootBlocks
            maintitle="¿Qué acción deseas realizar?"
            columnsPerRow={2}
            blocks={[
                { ico: "bi bi-bounding-box", title: "Matriz de horas", link: ROUTES.EDIT_HOURS_MATRIX},
                { ico: "bi bi-bounding-box", title: "Costo de horas", link: ROUTES.LIST_PRICING_HOURS}
            ]}
        />
    );
}